import React, { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import { columns } from './columns';
import Profile from './Profile'
import { UserOutlined, SearchOutlined, FileExcelOutlined, FilterOutlined } from '@ant-design/icons';
import { PageHeader, Row, Col, Table, Breadcrumb, Pagination, Button, Modal, Form , Space, Timeline, Empty, Select, AutoComplete, Input, Popover, Checkbox, Tooltip, DatePicker, Typography, Tag, Divider, Spin, Radio, message } from 'antd';
import { assignToJob } from '../../../redux/actions/counselingProcess/counselingProcessAction';
import { listAssignedCandidate, unmountListAssignedCandidate, createNotes, exportData, reassignToJobByFilter } from '../../../redux/actions/assignedCandidates/assignedCandidateAction';
import { masterEducationLevel, unmountMasterEducationLevel } from '../../../redux/actions/master/educationLevel/educationLevelAction';
import { detailCandidate, unmountDetailCandidate } from '../../../redux/actions/candidate/candidateAction';
import { listJobs, unmountListJobs } from '../../../redux/actions/jobs/jobsAction';
import { download } from '../../../utils/document';

const { RangePicker } = DatePicker;
const { Text } = Typography;
const { confirm, warning } = Modal;
const { TextArea } = Input;

class AssignedCandidateList extends Component {
  formRef = React.createRef()
  formAssignRef = React.createRef()
  formBulkRef = React.createRef()
  constructor(props) {
    super(props)
  
    this.state = {
      visible: false,
      visibleAction: false,
      visibleAssignJob: false,
      visibleApplicant: false,
      visibleHistory: false,
      selectedRows: [],
      selectedRowKeys: [],
      submitLoading: false,
      url: 'job_admin',
      meta: {
        page: 1,
        perpage: 20
      },
      metaJob: {
        page: 1,
        perpage: 10,
        search: '',
        status: 'ACTIVE'
      },
      candidateNotes: [],
      candidateId: null,
      candidateNumber: null, 
      candidateName: null,
      jobId: null,
      listHistory: []
    }
    this.onSearch = debounce(this.onSearch.bind(this), 900)
  }

  componentDidMount() {
    const { meta } = this.state
    const { actionGetData, actionGetEducationLevel } = this.props
    actionGetData(meta)
    actionGetEducationLevel()
  }

  onRegistered = value => {
    const { actionGetData } = this.props
    const { meta } = this.state
    meta.page = 1
    meta.perpage = 20
    meta.startDate = value.startDate
    meta.endDate = value.endDate
    return actionGetData(meta)
  }

  handleRangePicker = (dates, dateStrings) => {
    const date = {
      'startDate': dateStrings[0],
      'endDate': dateStrings[1]
    }
    return this.onRegistered(date)
  }

  handleFilterClear = () => {
    const { actionGetData } = this.props
    const { meta } = this.state
    meta.page = 1
    meta.perpage = 20
    delete meta.educationLevelId
    delete meta.gender
    delete meta.age
    delete meta.experience
    delete meta.category
    this.formRef.current.setFieldsValue({
      educationLevelId: null,
      gender: null,
      age: null,
      experience: null,
      category: null
    })
    this.setState({ meta })
    return actionGetData(meta)
  }

  handleFilterEducation = value => {
    const { meta } = this.state
    meta.page = 1
    meta.perpage = 20
    meta.educationLevelId = value
  }

  handleFilterGender = value => {
    const { meta } = this.state
    meta.page = 1
    meta.perpage = 20
    meta.gender = value.toString()
  }

  handleFilterAge = value => {
    const { meta } = this.state
    meta.page = 1
    meta.perpage = 20
    meta.age = value
  }

  handleFilterSource = value => {
    const { meta } = this.state
    meta.page = 1
    meta.perpage = 20
    meta.candidateSource = value.toString()
  }

  handleFilterExperience = value => {
    const { meta } = this.state
    meta.page = 1
    meta.perpage = 20
    meta.experience = value
  }

  handleFilterStatus = value => {
    const { meta } = this.state
    meta.page = 1
    meta.perpage = 20
    meta.category = value.toString()
  }

  handleAddFilter = () => {
    const { actionGetData } = this.props
    const { meta } = this.state
    this.setState({ visible: false })
    return actionGetData(meta)
  }

  handleOpenChange = (newOpen) => {
    this.setState ({visible: newOpen});
  };

  handleCloseTag = (value) => {
    const { actionGetData } = this.props
    const { meta } = this.state
    meta.page = 1
    meta.perpage = 20
    delete meta[value]
    this.formRef.current.setFieldsValue({
      [value]: null
    })
    this.setState({ meta })
    return actionGetData(meta)
  }

  onSearch = value => {
    const { meta } = this.state
    const { actionGetData } = this.props
    meta.page = 1
    meta.perpage = 20
    meta.search = value === '' ? null : value
    return actionGetData(meta)
  }

  pagination = (page, perpage) => {
    const { actionGetData } = this.props
    const { meta } = this.state
    meta.page = page
    meta.perpage = perpage
    return actionGetData(meta)
  }

  onClickRow = (record) => {
    this.props.history.push(`/assigned-candidate/detail/${record.candidateId}/biodata`)
    localStorage.setItem("status", "assigned-candidate")
  }

  onChangeCheck = (selectedRowKeys_) => {
    const { selectedRowKeys } = this.state
    const data = selectedRowKeys.concat(selectedRowKeys_)
    const uniqueData = data.filter((val,candidateId,array) => array.indexOf(val) === candidateId)
    this.setState({ selectedRowKeys: uniqueData })
  }

  onSelectCheck = (record, selected) => {
    const { selectedRows, selectedRowKeys } = this.state
    if(selected){
      selectedRows.push({ id: record.candidateId, status: record.jobAppliedStatus, candidateNumber: record.candidateNumber, candidateName: record.fullName })
    }else{
      const objWithIdIndex = selectedRows.findIndex((obj) => obj.id === record.candidateId)
      if(objWithIdIndex > -1) {
        selectedRows.splice(objWithIdIndex, 1)
        selectedRowKeys.splice(objWithIdIndex, 1)
      }
    }
    this.setState({ selectedRows, selectedRowKeys })
  }

  onSelectCheckAll = (selected, selectedRows_, changeRows) => {
    const { selectedRows, selectedRowKeys } = this.state
    if(selected){
      changeRows.forEach((item) => {
        selectedRows.push({ id: item.candidateId, status: item.jobAppliedStatus, candidateNumber: item.candidateNumber, candidateName: item.fullName })
      })
    }else{
      changeRows.forEach((item) => {
        const objWithIdIndex = selectedRows.findIndex((obj) => obj.id === item.candidateId)
        if(objWithIdIndex > -1) {
          selectedRows.splice(objWithIdIndex, 1)
          selectedRowKeys.splice(objWithIdIndex, 1)
        }
      })
    }
    this.setState({ selectedRows, selectedRowKeys })
  }
  
  showModalNotes = (val, candidateId) => {
    this.setState({ visibleNotes: true, candidateNotes: val, candidateId: candidateId })
  };

  showModalAssignJob = (candidateId, candidateNumber, candidateName) => {
    this.setState({ visibleAssignJob: true, candidateId: candidateId, candidateNumber: candidateNumber, candidateName: candidateName })
  }

  showModalApplicant = (id) => {
    const { actionGetProfile } = this.props;
    const { candidateId } = this.state;
    this.setState({ visibleApplicant: true, visibleAssignJob : false })
    actionGetProfile(id ? id : candidateId)
  }

  showModalAction = () => {
    this.setState({ visibleAction: true })
  };

  showModalHistory = (data) => {
    this.setState({ visibleHistory: true, listHistory: data })
  }

  handleCancel = (status) => {
    const { unmountGetProfile } = this.props
    if(status === 'profile'){
      this.setState({ visibleNotes: false, visibleAssignJob: true, visibleApplicant : false, visibleAction: false, visibleHistory: false })
      unmountGetProfile()
    }else{
      this.setState({ visibleNotes: false, visibleAssignJob: false, visibleApplicant : false, visibleAction: false, visibleHistory: false, candidateId: null, jobId: null })
    }
  }

  onFinishNotes = (value) => {
    const { actionCreateNotes, actionGetData } = this.props
    const { candidateId, meta} = this.state
    value.candidateId = candidateId
    return this.setState({ submitLoading: true }, () => {
      return actionCreateNotes(value, response => {
        if(response.code === '1000'){
          setTimeout(() => {
            this.setState({ submitLoading: false, visibleNotes: false })
            message.success('successfully added notes!')
          }, actionGetData(meta, response => {
          }), 1000)
        }else{
          return this.setState({ submitLoading: false, visibleNotes: false }, () => message.error(response.message))
        }
      }, (err) => {
        return this.setState({ submitLoading: false, visibleNotes: false }, () => message.error(err))
      })
    })
  }

  modalExportData = (id) => {
    const self = this;
    const { selectedRowKeys } = this.state;
    const { actionExportData } = this.props;
    confirm({
      title: <Text>Candidates data will be exported to excel</Text>,
      content: 'Are you sure?',
      width: 480,
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        const value = {
          candidateId: id ? id : selectedRowKeys.toString()
        }
        actionExportData(value, (response) => {
          return download(response, 'Assigned Candidate Data.xls')
        })
        self.setState({ selectedRowKeys: [], selectedRows: [] })
      },
    });
  }

  warningNoSelected = () => {
    warning({
      title: 'Please select a record',
    });
  };

  warningSelectRejected = () => {
    warning({
      title: <Text>Please select record with status 'Rejected' </Text>,
    });
  };

  onSearchJob = value => {
    const { metaJob, url } = this.state;
    const { actionGetJob } = this.props;

    metaJob.page = 1
    metaJob.perpage = 10
    metaJob.search = value

    return actionGetJob(metaJob, url)
  }

  onFocusJob = () => {
    const { metaJob, url } = this.state;
    const { actionGetJob } = this.props;
    return actionGetJob(metaJob, url)
  }

  onSelectJob = (_,res) => {
    this.setState({ jobId: res.key })
  }

  onFinishAssignJob = () => {
    const { jobId, candidateId, selectedRowKeys, valuesBulk, meta } = this.state
    const { actionAssignJob, actionAssignJobByFilter, actionGetData } = this.props
    if(valuesBulk.gender === 'ALL'){
      delete valuesBulk.gender
    }
    this.formAssignRef.current.validateFields().then(values => {
      values.jobId = jobId
      if(valuesBulk){
        return actionAssignJobByFilter(values, valuesBulk, (response) => {
          if(response.code === '1000'){
            message.success(response.data)
            this.setState({ visibleAssignJob: false })
            return actionGetData(meta)
          }else if(response.code === '3170'){
            message.info(response.message)
            this.setState({ visibleAssignJob: false })
          }else{
            message.error(response.message)
            this.setState({ visibleAssignJob: false })
          }
        }, (err) => message.error(err))
      }else{
        values.candidateId = candidateId ? [candidateId] : selectedRowKeys
        return actionAssignJob(values, (response) => {
          if(response.code === '1000'){
            message.success('Successfully re-assign to Job')
            this.setState({ selectedRowKeys: [], selectedRows: [], visibleAssignJob: false })
            return actionGetData(meta)
          }else if(response.code === '3170'){
            message.info(response.message)
            this.setState({ selectedRowKeys: [], selectedRows: [], visibleAssignJob: false })
          }else{
            message.error(response.message)
            this.setState({ selectedRowKeys: [], selectedRows: [], visibleAssignJob: false })
          }
        }, (err) => message.error(err))
      }
    })
  }

  onFinishBulk = (values) => {
    this.setState({ visibleAction: false, visibleAssignJob: true, valuesBulk: values })
  }

  handleBulkEducation = (_,res) => {
    this.setState({ educationLevel: res.children })
  }

  render() {
    const { visibleNotes, visibleAssignJob, visibleApplicant, visibleAction, visibleHistory, selectedRowKeys, selectedRows, candidateNotes, meta, candidateId, candidateNumber, candidateName, listHistory, valuesBulk, educationLevel, visible } = this.state
    const { getData: { data, loading , pagination }, getEducationLevel, getJob, tooltipDate } = this.props
    
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onChangeCheck,
      onSelect: this.onSelectCheck,
      onSelectAll: this.onSelectCheckAll
    }

    return (
      <React.Fragment>
        <Row gutter={[8, 0]}>
          {/* Breadcrumb */}
          <Col span={24}>
            <Breadcrumb>
              <Breadcrumb.Item><UserOutlined /> Assigned Candidates</Breadcrumb.Item>
              <Breadcrumb.Item>Assigned Candidates List</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          {/* Page Header */}
          <Col span={24}>
            <PageHeader className="site-page-header" title='Assigned Candidate List' />
          </Col>
          {/* Filter */}
          <Col span={5}>
            <Tooltip title={tooltipDate}>
              <RangePicker
                onChange={this.handleRangePicker}
                format={'DD-MM-YYYY'}
                style={{ width: '100%' }}
                ranges={{
                  Today: [moment(), moment()],
                  'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                  'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                  'This Week': [moment().startOf('week'), moment().endOf('week')],
                  'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                  'This Month': [moment().startOf('month'), moment().endOf('month')],
                  'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                }}
              />
            </Tooltip>
          </Col>
          <Col span={3}>
            <Popover
              placement="rightTop" 
              trigger="click"
              open={visible}
              onOpenChange={this.handleOpenChange}
              content={
                <Form ref={this.formRef}>
                  <Row gutter={[0,8]} style={{ width: 300 }}>
                    <Col span={24}>
                      <Text className="link row-pointer" onClick={this.handleFilterClear} style={{ float: 'right' }}>Clear All</Text>
                    </Col>
                    <Col span={24}>
                      <Text strong>Education</Text>
                    </Col>
                    <Col span={24}>
                      <Form.Item name="educationLevelId" style={{ margin: 0 }}>
                        <Select onChange={this.handleFilterEducation} placeholder="Select Level" style={{ width: '100%', float: 'right' }}>
                          {
                            getEducationLevel?.data?.map(item => 
                              <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                              )
                          }
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Text strong>Gender</Text>
                    </Col>
                    <Col span={24}>
                      <Form.Item name="gender" style={{ margin: 0 }}>
                        <Checkbox.Group onChange={(checkedValues) => this.handleFilterGender(checkedValues)} style={{ display: 'grid' }}>
                          <Checkbox key="1" value="MALE" style={{ marginLeft: 0 }}>Man</Checkbox>
                          <Checkbox key="2" value="FEMALE" style={{ marginLeft: 0 }}>Woman</Checkbox>
                        </Checkbox.Group>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Text strong>Age</Text>
                    </Col>
                    <Col span={24}>
                      <Form.Item name="age" style={{ margin: 0 }}>
                        <Select onChange={this.handleFilterAge} placeholder="Select Age" style={{ width: '100%', float: 'right' }}>
                          <Select.Option key="1" value="<17">{`<17`}</Select.Option>
                          <Select.Option key="2" value="17-21">17-21</Select.Option>
                          <Select.Option key="3" value="22-26">22-26</Select.Option>
                          <Select.Option key="4" value="27-31">27-31</Select.Option>
                          <Select.Option key="5" value="32-36">32-36</Select.Option>
                          <Select.Option key="6" value="37-41">37-41</Select.Option>
                          <Select.Option key="7" value="42-46">42-46</Select.Option>
                          <Select.Option key="8" value=">46">{`>46`}</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Text strong>Experiences</Text>
                    </Col>
                    <Col span={24}>
                      <Form.Item name="experience" style={{ margin: 0 }}>
                        <Select onChange={this.handleFilterExperience} placeholder="Select Level" style={{ width: '100%', float: 'right' }}>
                          <Select.Option key="1" value="<1">{`<1 years`}</Select.Option>
                          <Select.Option key="2" value="1-2">1-2 years</Select.Option>
                          <Select.Option key="3" value="3-5">3-5 years</Select.Option>
                          <Select.Option key="4" value=">5">{`>5 years`}</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Text strong>Job Status</Text>
                    </Col>
                    <Col span={24}>
                      <Form.Item name="category" style={{ margin: 0 }}>
                        <Checkbox.Group onChange={(checkedValues) => this.handleFilterStatus(checkedValues)} style={{ display: 'grid' }}>
                          <Checkbox key="1" value="APPLIED" style={{ marginLeft: 0 }}>Applied</Checkbox>
                          <Checkbox key="2" value="SHORTLISTED" style={{ marginLeft: 0 }}>Shortlisted</Checkbox>
                          <Checkbox key="3" value="ASSESSMENT" style={{ marginLeft: 0 }}>Assesment</Checkbox>
                          <Checkbox key="4" value="QUALIFIED" style={{ marginLeft: 0 }}>Qualified</Checkbox>
                          <Checkbox key="5" value="INTERVIEW" style={{ marginLeft: 0 }}>Interview</Checkbox>
                          <Checkbox key="6" value="OFFERED" style={{ marginLeft: 0 }}>Offered</Checkbox>
                          <Checkbox key="7" value="DEPARTURE" style={{ marginLeft: 0 }}>Departure</Checkbox>
                          <Checkbox key="8" value="HIRED" style={{ marginLeft: 0 }}>Hired</Checkbox>
                          <Checkbox key="9" value="REJECTED" style={{ marginLeft: 0 }}>Rejected</Checkbox>
                        </Checkbox.Group>
                      </Form.Item>
                    </Col>
                    <Col span={24} style={{ marginTop: 8 }}>
                      <Button type="primary" onClick={this.handleAddFilter} style={{ width: '100%' }}>Add Filter</Button>
                    </Col>
                  </Row>
                </Form>
              }
            >
              <Button style={{ width: '100%', borderRadius: 6 }}>
                Filter <FilterOutlined />
              </Button>
            </Popover>
          </Col>
          <Col span={12}>
            <AutoComplete 
              onSearch={this.onSearch} 
              style={{ width: '100%' }} 
              allowClear
            >
              <Input prefix={<SearchOutlined />} placeholder="Search by Name, Email"  />
            </AutoComplete>
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Divider size="large" type="vertical" style={{ height: '100%' }} />
          </Col>
          <Col span={3}>
            <Button type="primary" onClick={this.showModalAction} style={{ width: '100%', borderRadius: 6 }}>Action</Button>
          </Col>
          
          {/* Button */}
          <Col span={24}>
            {
              selectedRowKeys.length > 0 ? 
              <React.Fragment>
                <Col span={24} style={{ marginTop: 8 }}>
                  <Space>
                    <Text>Selected Candidate: <Text strong>{selectedRowKeys?.length}</Text></Text>
                    <Button 
                      className="btn-color-blue"
                      size='small'
                      type="primary" 
                      ghost
                      onClick={
                        selectedRowKeys.length > 0 ? 
                          selectedRows.find(res => res.status === 'Applied') ?
                            this.warningSelectRejected 
                          :
                            () => this.showModalAssignJob(null) 
                        : 
                          this.warningNoSelected}
                    > 
                      Re-Assign Job
                    </Button>

                    <Button 
                      className="btn-create-primary" 
                      type="primary" 
                      size='small'
                      ghost
                      onClick={selectedRowKeys.length > 0 ? () => this.modalExportData(null) : this.warningNoSelected}
                    >
                      Export Data <FileExcelOutlined />
                    </Button>
                  </Space>
                </Col>
              </React.Fragment>
            : null
            }
          </Col>
          
          {/* Value Filter */}
          {
            meta.hasOwnProperty('educationLevelId') || meta.hasOwnProperty('gender') || meta.hasOwnProperty('age') || meta.hasOwnProperty('experience') || meta.hasOwnProperty('category') ?
              <Col span={24} style={{ paddingTop: 8 }}>
                <Space>
                  <Text>Filter Active:</Text>
                  <Space size={0}>
                    {
                      meta.hasOwnProperty('educationLevelId') ? 
                        <Tag
                          color="green"
                          closable
                          onClose={() => this.handleCloseTag('educationLevelId')}
                          style={{ padding: '4px 16px', borderRadius: 32 }}
                        >
                          Education
                        </Tag>
                      : null
                    }
                    {
                      meta.hasOwnProperty('gender') ? 
                        <Tag
                          color="green"
                          closable
                          onClose={() => this.handleCloseTag('gender')}
                          style={{ padding: '4px 16px', borderRadius: 32 }}
                        >
                          Gender
                        </Tag>
                      : null
                    }
                    {
                      meta.hasOwnProperty('age') ? 
                        <Tag
                          color="green"
                          closable
                          onClose={() => this.handleCloseTag('age')}
                          style={{ padding: '4px 16px', borderRadius: 32 }}
                        >
                          Age
                        </Tag>
                      : null
                    }
                    {
                      meta.hasOwnProperty('experience') ? 
                        <Tag
                          color="green"
                          closable
                          onClose={() => this.handleCloseTag('experience')}
                          style={{ padding: '4px 16px', borderRadius: 32 }}
                        >
                          Experiences
                        </Tag>
                      : null
                    }
                    {
                      meta.hasOwnProperty('category') ? 
                        <Tag
                          color="green"
                          closable
                          onClose={() => this.handleCloseTag('category')}
                          style={{ padding: '4px 16px', borderRadius: 32 }}
                        >
                          Job Status
                        </Tag>
                      : null
                    }
                  </Space>
                  <Button type="text" onClick={this.handleFilterClear}>Clear All</Button>
                </Space>
              </Col>
            : null
          }

          {/* Table */}
          <Col span={24} style={{ marginTop: 8 }}>
            <Table 
              size="small" 
              rowKey={(i) => i.candidateId} 
              pagination={false}
              loading={loading} 
              scroll={{ x: 1500 }}
              rowSelection={rowSelection}
              dataSource={data} columns={columns(this.onClickRow, this.showModalNotes, this.showModalAssignJob, this.showModalHistory, this.modalExportData)}
            />
          </Col>
          {/* Pagination */}
          <Col span={24} style={{ marginTop: 8 }}>
            <Pagination
              total={pagination.total}
              onChange={this.pagination}
              current={pagination.page}
              pageSize={pagination.perpage}
              pageSizeOptions={[20,50,100,200]}
              showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} Data`}
              size='small'
            />
          </Col>
        </Row>

        <Modal
          title={`Recruitment Notes`}
          visible={visibleNotes}
          width={600}
          onCancel={() => this.handleCancel(null)}
          footer= {false}
          destroyOnClose
        >
          <Row>
            <Col span={24}>
              <Form layout='vertical' onFinish={this.onFinishNotes}>
                <Form.Item
                  name="note"
                  rules={[
                    { required: true, message: 'This is a required field' },
                    { max: 200, message: '200 characters only' },
                  ]}
                >
                  <TextArea rows={2} placeholder='Write a notes'
                >
                  </TextArea>
                </Form.Item>
                
                <Button 
                  className="btn-create-primary" 
                  type="primary" 
                  ghost 
                  style={{float : 'right'}}
                  htmlType = "submit"
                >
                  Submit
                </Button>
              </Form>
            </Col>

            <Col span={24} style={{marginTop: 32}}>
              {
                candidateNotes?.length > 0 ? 
                  <Timeline mode='left' style={{ paddingRight: 264 }}>
                    {
                      candidateNotes.map((item,i) => 
                        <Timeline.Item key={i} label={<Text style={{ fontSize: 12 }}>{item.createdDate}</Text>}>
                          <Space direction="vertical" size={0} style={{ width: 388 }}>
                            <Text style={{ fontSize: 12 }}>{item.note}</Text>
                            <Text style={{ color: '#0076de', fontSize: 12 }}>{item.stage}</Text>
                          </Space>
                        </Timeline.Item>
                      )
                    }
                  </Timeline>
                : 
                  <Empty />
              }
            </Col>
          </Row>
        </Modal>

        <Modal
          title="History"
          visible={visibleHistory}
          width={600}
          onCancel={() => this.handleCancel(null)}
          footer= {false}
          destroyOnClose
        >
          <Row>
            <Col span={24}>
              {
                listHistory?.length > 0 ? 
                  <Timeline mode='left' style={{ paddingRight: 264 }}>
                    {
                      listHistory.map((item,i) => 
                        <Timeline.Item key={i} label={<Text style={{ fontSize: 12 }}>{item.createdDate}</Text>}>
                          <Space direction="vertical" size={0} style={{ width: 388 }}>
                            {
                              item.phaseName === 'ASSIGNED' ?
                                <Text style={{ color: '#1889FA', fontSize: 12 }}>Assigned to:</Text>
                              :
                                <Text style={{ color: '#F58181', fontSize: 12 }}>Rejected from:</Text>
                            }
                            <Text style={{ fontSize: 12 }}>{item.assignedTo}</Text>
                          </Space>
                        </Timeline.Item>
                      )
                    }
                  </Timeline>
                : 
                  <Empty />
              }
            </Col>
          </Row>
        </Modal>

        <Modal
          title="Re-assign to a Job"
          width={800}
          visible={visibleAssignJob}
          destroyOnClose
          onCancel={() => this.handleCancel(null)}
          footer={[
            <React.Fragment key="assignJob">
              <Button key="back" className="btn-save-primary" onClick={() => this.handleCancel(null)}>Cancel</Button>
              <Button key="submit" className="btn-save-primary" type="primary" onClick={this.onFinishAssignJob}>Re-assign</Button>
            </React.Fragment>
          ]}
        >
          <Form ref={this.formAssignRef} onFinish={this.onFinishAssignJob} layout='vertical'>
            <Row gutter={32}>
              <Col span={12}>
                <Space direction='vertical'>
                  <Text>{selectedRowKeys.length > 0 ? `${selectedRowKeys.length} Candidates` : 'Candidates'}</Text>
                  {
                    valuesBulk ?
                      <Text style={{ color: '#4273B9' }}>
                        {
                          `Filter by: 
                          ${valuesBulk?.educationLevelId ? `Education(${educationLevel}), ` : ''}
                          ${valuesBulk?.gender === 'MALE' ? `Gender(Man), ` : valuesBulk?.gender === 'FEMALE' ? `Gender(Women), ` : ''}
                          ${valuesBulk?.age ? `Age(${valuesBulk?.age}), ` : ''}
                          ${valuesBulk?.experience ? `Experiences(${valuesBulk?.experience} years), ` : ''}
                          Job Status(Rejected)`
                        }
                      </Text>
                    :
                      candidateId ?
                        <Space size={0}>
                          <Text className='row-pointer' onClick={() => this.showModalApplicant(null)} style={{ color: '#0076de' }}>{candidateNumber}</Text>
                          <Text>-{candidateName}</Text>
                        </Space>
                      :
                        <div className="frame" style={{ height: selectedRowKeys.length > 4 ? 110 : selectedRowKeys.length > 3 ? 90 : selectedRowKeys.length > 2 ? 70 : selectedRowKeys.length > 1 ? 60 : 30, overflowY: 'auto' }}>
                          {
                            selectedRows.map((item, i) =>
                              <Space key={i} size={0}>
                                <Text className='row-pointer' onClick={() => this.showModalApplicant(item.id)} style={{ color: '#0076de' }}>{item.candidateNumber}</Text>
                                <Text>-{item.candidateName}</Text>
                              </Space>
                            )
                          }
                        </div>
                  }
                </Space>
              </Col>
              <Col span={12}>
                <Form.Item name="jobId" label="Assign to">
                  <Select
                    onFocus={this.onFocusJob}
                    onSearch={this.onSearchJob}
                    onSelect={this.onSelectJob}
                    showSearch
                    notFoundContent={getJob?.loading ? <Spin size="small" /> : null}
                    filterOption={false}
                    options={
                      getJob?.data?.map(res => ({
                        key: res.id,
                        label: res.title,
                        value: res.title
                      }))
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={24} style={{ marginTop: 8 }}>
                <Form.Item 
                  label="Notes" 
                  name="notes"
                  rules={[
                    { max: 1000, message: '1000 characters only' },
                  ]}
                >
                  <Input.TextArea rows={3} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>

        <Modal
          centered
          title="Applicant Profile"
          width={800}
          visible={visibleApplicant}
          destroyOnClose
          onCancel={() => this.handleCancel('profile')}
          footer={[
            <>
              <ReactToPrint
                key="print"
                trigger={() => <Button>Download CV</Button>}
              />
              <Button key="back" type="primary" onClick={() => this.handleCancel('profile')}>Okay</Button>
            </>
          ]}
        >
          <Profile {...this.props} />
        </Modal>
        
        <Modal
          title={<Text strong>Re-assign to a Job in Bulk</Text>}
          visible={visibleAction}
          onCancel={this.handleCancel}
          footer= {false}
          destroyOnClose
        >
          <Form ref={this.formBulkRef} onFinish={this.onFinishBulk}>
            <Row gutter={[0,8]}>
              <Col span={24}>
                <Text strong>Education</Text>
              </Col>
              <Col span={24}>
                <Form.Item name="educationLevelId" style={{ margin: 0 }}>
                  <Select onChange={this.handleBulkEducation} placeholder="Select Level" style={{ width: '100%', float: 'right' }}>
                    {
                      getEducationLevel?.data?.map(item => 
                        <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                        )
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Text strong>Gender</Text>
              </Col>
              <Col span={24}>
                <Form.Item name="gender" style={{ margin: 0 }} initialValue="ALL">
                  <Radio.Group>
                    <Space direction="vertical" size={0}>
                      <Radio key="1" value="ALL" style={{ marginLeft: 0 }}>All</Radio>
                      <Radio key="2" value="MALE" style={{ marginLeft: 0 }}>Man</Radio>
                      <Radio key="3" value="FEMALE" style={{ marginLeft: 0 }}>Woman</Radio>
                    </Space>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Text strong>Age</Text>
              </Col>
              <Col span={24}>
                <Form.Item name="age" style={{ margin: 0 }}>
                  <Select placeholder="Select Age" style={{ width: '100%', float: 'right' }}>
                    <Select.Option key="1" value="<17">{`<17`}</Select.Option>
                    <Select.Option key="2" value="17-21">17-21</Select.Option>
                    <Select.Option key="3" value="22-26">22-26</Select.Option>
                    <Select.Option key="4" value="27-31">27-31</Select.Option>
                    <Select.Option key="5" value="32-36">32-36</Select.Option>
                    <Select.Option key="6" value="37-41">37-41</Select.Option>
                    <Select.Option key="7" value="42-46">42-46</Select.Option>
                    <Select.Option key="8" value=">46">{`>46`}</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Text strong>Experiences</Text>
              </Col>
              <Col span={24}>
                <Form.Item name="experience" style={{ margin: 0 }}>
                  <Select placeholder="Select Level" style={{ width: '100%', float: 'right' }}>
                    <Select.Option key="1" value="<1">{`<1 years`}</Select.Option>
                    <Select.Option key="2" value="1-2">1-2 years</Select.Option>
                    <Select.Option key="3" value="3-5">3-5 years</Select.Option>
                    <Select.Option key="4" value=">5">{`>5 years`}</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Text strong>Job Status</Text>
              </Col>
              <Col span={24} style={{ marginTop: -8 }}>
                <Text style={{ fontSize: 12 }}>Rejected (You can only re-assign to a job with current job status is Rejected)</Text>
              </Col>
              <Col span={24} style={{ marginTop: 8 }}>
                <Space style={{ float: 'right' }}>
                  <Button onClick={this.handleCancel}>Cancel</Button>
                  <Button type="primary" htmlType='submit'>Next</Button>
                </Space>
              </Col>
            </Row>
          </Form>
        </Modal>
      </React.Fragment>
    )
  }
  
  componentWillUnmount() {
    const { unmountGetData, unmountMasterEducationLevel } = this.props
    unmountGetData()
    unmountMasterEducationLevel()
  }
}

const mapStateToProps = (state) => ({
  getData           : state.assignedCandidate.list,
  getEducationLevel : state.educationLevel.master,
  getProfile        : state.candidate.detail,
  getJob            : state.jobs.list
})

const mapDispatchToProps = {
  actionGetData               : listAssignedCandidate,
  actionGetEducationLevel     : masterEducationLevel,
  actionCreateNotes           : createNotes,
  actionGetProfile            : detailCandidate,
  actionGetJob                : listJobs,
  actionAssignJob             : assignToJob,
  actionExportData            : exportData,
  actionAssignJobByFilter     : reassignToJobByFilter,
  unmountGetData              : unmountListAssignedCandidate,
  unmountMasterEducationLevel : unmountMasterEducationLevel,
  unmountGetProfile           : unmountDetailCandidate,
  unmountGetJob               : unmountListJobs
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignedCandidateList)
